"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc20ApprovalTransaction = void 0;
var abi_1 = require("@ethersproject/abi");
var ERC20_json_1 = __importDefault(require("../abi/ERC20.json"));
var types_1 = require("../types");
var encodeTokenApproval = function (approvedAddress, approvalAmount) {
    return new abi_1.Interface(ERC20_json_1.default).encodeFunctionData("approve(address,uint256)", [approvedAddress, approvalAmount]);
};
exports.erc20ApprovalTransaction = function (tokenAddress, spender, amount) { return ({
    to: tokenAddress,
    typeCode: types_1.CallType.Call,
    data: encodeTokenApproval(spender, amount),
    value: "0",
}); };
